import styled from 'styled-components'

import { BaseText } from '../BaseText'

export const SubTextStyled = styled(BaseText)`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.body2)};
  line-height: ${(props) => props.theme.typography.pxToRem(16)};

  sup {
    vertical-align: super;
    font-size: ${(props) => props.theme.typography.pxToRem(8)};
  }
`
